<div *ngIf="canSeePropertyNotes" class="col-12 notes-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="notes">Mes notes personnelles
        <a class="info" (click)="showPropertyNotesInfo()" appTooltip="Plus d'informations" class="more-info">
          <mat-icon class="align-top info" color="primary" aria-label="Plus d'informations">info</mat-icon>
        </a></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="notes">
        {{ propertyNotes }}
      </div>
      <mat-action-row *ngIf="canUpdatePropertyNotes">
        <button mat-mini-fab color="primary" (click)="editNotes()" appTooltip="Modifier">
          <mat-icon aria-label="Modifier">create</mat-icon>
        </button>
      </mat-action-row>
    </mat-card-content></mat-card>
</div>
<div class="col-12">
  <app-property-attributes-view [prop]="prop" [category]="category"></app-property-attributes-view>
</div>

<div class="col-12 people">
  <app-property-people-table *ngIf="isPeopleListFeatureAvailable" [prop]="prop"></app-property-people-table>
</div>
<div class="col-12 doc">
  <app-property-doc-view [prop]="prop" [category]="category"></app-property-doc-view>
</div>